import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import Loader from "../../../components/Loader";
import SidebarFilter from "../../../components/SidebarFilter";
import { Biscuit, getAllUrlParams } from "../../../../utils";
import { $, moment } from "../../../../../vendor";
import { getFilterData } from "../../../../utils/Helper";

const ErrorsSidebar = (props) => {
  const language = Biscuit.get("user.lang").replace("-", "_");
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  allUrlParams?.priority_name !== undefined && delete allUrlParams.priority_name;
  allUrlParams?.type_name !== undefined && delete allUrlParams.type_name;
  const [ready, setReady] = useState(false);
  const cleanState = {
    clientFilter: false,
    codeFilter: false,
    urlFilter: false,
    priorityFilter: false,
    typeFilter: false,
    dateFilter: false,
  };
  const [usedFilterCount, setUsedFilterCount] = useState({
    clientFilter: allUrlParams?.client_id !== undefined,
    codeFilter: allUrlParams?.code !== undefined,
    urlFilter: allUrlParams?.url !== undefined,
    priorityFilter: allUrlParams?.priority !== undefined,
    typeFilter: allUrlParams?.type !== undefined,
    dateFilter: allUrlParams.date !== undefined,
  });
  const [filterCount, setFilterCount] = useState(
    Object.keys(allUrlParams).length > 0 ? Object.keys(allUrlParams).length : 0,
  );
  // default values?
  const [typeFilter, setTypeFilter] = useState(
    searchParams.get("type") !== null ? searchParams.get("type") : "all",
  );
  const [priorityFilter, setPriorityFilter] = useState(
    searchParams.get("priority") !== null ? searchParams.get("priority") : "all",
  );
  const [clientId, setClientId] = useState(
    searchParams.get("client_id") !== null ? searchParams.get("client_id") : "",
  );
  const [code, setCode] = useState(
    searchParams.get("code") !== null ? searchParams.get("code") : "",
  );
  const [url, setUrl] = useState(searchParams.get("url") !== null ? searchParams.get("url") : "");
  const [_resetFilter, _setResetFilter] = useState(props.resetFilter);
  const [globalFilter, setGlobalFilter] = useState({});
  const [selectedDate, setSelectedDate] = useState(
    searchParams.get("date") !== null
      ? moment(searchParams.get("date"), "YYYY-MM-DD").toDate()
      : null,
  );
  let types = props.types;

  let tempData = [t("all")];
  for (let index = 0; index < types.length; index++) {
    tempData.push(types[index]);
  }
  types = tempData;

  useEffect(() => {
    if (!_resetFilter) return;

    if (_resetFilter) {
      props.resetFilter(false);
    }
    _setResetFilter(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_resetFilter]);

  /**
   * can be generally defined in common sidebar
   * @param {event} ev
   */
  const onToggleLeftBar = (ev) => {
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);
  };

  const onFilterCountChangeHandle = (value) => {
    let clone = { ...value };
    let count = 0;
    for (const [type, val] of Object.entries(clone)) {
      if (val) {
        count++;
      }
    }
    if (count < 1) {
      count = 0;
      $("#inb-selected-filters").addClass("hidden");
    } else {
      $("#inb-selected-filters").removeClass("hidden");
    }
    setFilterCount(count);
  };

  const resetFilter = (dispatch = true) => {
    let clone = {};
    setClientId("");
    setSelectedDate(null);
    setPriorityFilter("all");
    setTypeFilter("all");
    setUrl("");
    setFilterCount(0);
    setGlobalFilter(clone);
    setUsedFilterCount(cleanState);
    onFilterCountChangeHandle(cleanState);
    if (dispatch) {
      props.filterChangedHandle(clone, {
        sort: "id",
        direction: "desc",
      });
    } else {
      props.setFilter(clone);
    }
    const newRelativePathQuery = window.location.pathname;
    history.pushState(null, "", newRelativePathQuery);
  };

  const selectedDateHandle = (date) => {
    clone.day = moment(date).format("YYYY-MM-DD");
    setSelectedDate(date);
    // reset month and quick filter
    props.filterChangedHandle(clone);
  };

  const dateKeyDownHandle = (e) => {
    console.log("key down date: ", e);
  };

  const onClientIdSelectHandle = (query, fetch = true) => {
    onHandle(query, "client_id", "clientFilter", setClientId);
  };

  const onUrlSelectHandle = (query) => {
    onHandle(query, "url", "urlFilter", setUrl);
  };

  const onCodeSelectHandle = (query) => {
    onHandle(query, "code", "codeFilter", setCode);
  };

  const onPriorityFilterChange = (query) => {
    onHandle(query, "priority", "priorityFilter", setPriorityFilter);
  };

  const onTypeFilterChange = (query) => {
    onHandle(query, "type", "typeFilter", setTypeFilter);
  };

  const onHandle = (value, key, filter, func) => {
    if (typeof value !== "string") {
      value = value.target.value;
    }

    // should validate filter combination and start request

    let clone = { ...globalFilter };
    let clone2 = { ...usedFilterCount };
    if (key === "type") {
      searchParams.delete("priority");
      delete clone.priority;
      clone2.priorityFilter = false;
      setPriorityFilter("all");
    }
    if (key === "priority") {
      searchParams.delete("type");
      delete clone.type;
      clone2.typeFilter = false;
      setTypeFilter("all");
    }
    if (typeof value === "undefined" || value === null || value === "all") {
      delete clone[key];
      clone2[filter] = false;
      func("");
      searchParams.delete(key);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      clone[key] = value;
      clone2[filter] = true;
      func(value);
      searchParams.set(key, value);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    setUsedFilterCount(clone2);
    setGlobalFilter(clone);
    onFilterCountChangeHandle(clone2);
    // fetch wallet transactions
    if (fetch) {
      props.filterChangedHandle(clone);
    }
  };

  const initialize = () => {
    if (ready) return;
    setReady(true);
  };

  if (!ready) initialize();

  return (
    <aside id="inb-c-sidebar" className="filemanager-sidebar" style={{ float: "left" }}>
      <header className="inb-c-left-bar__title sticky-top">
        <h1 className="inb-page-title">{props.heading}</h1>
      </header>

      {!ready && <Loader mediumWidth={4} smallWidth={4} subLoaders={2} />}
      {ready && (
        <>
          <div className="sticky-top-filter">
            <aside id="inb-selected-filters">
              {filterCount > 0 && (
                <ul>
                  <p>
                    <i className="fi fi-filter"></i>
                    <span id="inb-selected-filters__count">{" " + filterCount}</span>

                    {" " + t("filter_selected")}
                    <a
                      href="#"
                      id="inb-selected-filters__unset"
                      className="unset-filter"
                      title={t("unselect_all_filter")}
                      onClick={() => {
                        resetFilter(true);
                      }}
                    >
                      x
                    </a>
                  </p>
                </ul>
              )}
            </aside>

            <ul id="inb-c-left-bar-flist--client_id" className="inb-vert-list">
              <span className="inb-list-title">{t("Client ID", null, "capital")}</span>
              <br />
              <input
                className="inbooma-input"
                name="client_id"
                key={"sidebar_search_client_id"}
                style={{ maxWidth: "180px" }}
                onChange={(e) => onClientIdSelectHandle(e)}
                value={clientId}
              ></input>
              {clientId !== undefined && clientId !== null && clientId !== "" && (
                <a
                  href="#"
                  className="inbooma-select-box__reset"
                  onClick={() => onClientIdSelectHandle("")}
                  style={{ float: "unset", paddingLeft: "5px" }}
                >
                  x
                </a>
              )}
            </ul>

            <ul id="inb-c-left-bar-flist--client_id" className="inb-vert-list">
              <span className="inb-list-title">{t("code", null, "capital")}</span>
              <br />
              <input
                className="inbooma-input"
                name="code"
                key={"sidebar_search_code"}
                style={{ maxWidth: "180px" }}
                onChange={(e) => onCodeSelectHandle(e)}
                value={code}
              ></input>
              {code !== undefined && code !== null && code !== "" && (
                <a
                  href="#"
                  className="inbooma-select-box__reset"
                  onClick={() => onCodeSelectHandle("")}
                  style={{ float: "unset", paddingLeft: "5px" }}
                >
                  x
                </a>
              )}
            </ul>

            <ul id="inb-c-left-bar-flist--client_id" className="inb-vert-list">
              <span className="inb-list-title">{t("url", null, "capital")}</span>
              <br />
              <input
                className="inbooma-input"
                name="url"
                key={"sidebar_search_url"}
                style={{ maxWidth: "180px" }}
                onChange={(e) => onUrlSelectHandle(e)}
                value={url}
              ></input>
              {url !== undefined && url !== null && url !== "" && (
                <a
                  href="#"
                  className="inbooma-select-box__reset"
                  onClick={() => onUrlSelectHandle("")}
                  style={{ float: "unset", paddingLeft: "5px" }}
                >
                  x
                </a>
              )}
            </ul>

            <ul id="inb-c-left-bar-flist--priority" className="inb-vert-list">
              <span className="inb-list-title">{t("priority", null, "capital")}</span>
              <br />
              <select
                className="inbooma-select-box__input"
                name="priorities"
                onChange={(e) => onPriorityFilterChange(e)}
                value={priorityFilter}
                style={{ maxWidth: "180px" }}
                placeholder={t("select_${a}", { a: t("priority") })}
              >
                {[
                  { value: "all", name: t("all") },
                  { value: 1, name: t("Sehr niedrig") },
                  { value: 2, name: t("Niedrig") },
                  { value: 3, name: t("Mittel") },
                  { value: 4, name: t("Hoch") },
                ].map((prio) => {
                  return (
                    <>
                      <option key={"prio_" + prio.value} value={prio.value}>
                        {prio.name}
                      </option>
                    </>
                  );
                })}
              </select>
              {priorityFilter !== undefined && priorityFilter !== null && (
                <a
                  href="#"
                  className="inbooma-select-box__reset"
                  onClick={() => onPriorityFilterChange("all")}
                  style={{ float: "unset", paddingLeft: "8%" }}
                >
                  x
                </a>
              )}
            </ul>

            <ul id="inb-c-left-bar-flist--type" className="inb-vert-list">
              <span className="inb-list-title">{t("errortype", null, "capital")}</span>
              <br />
              <select
                className="inbooma-select-box__input"
                name="types"
                onChange={(e) => onTypeFilterChange(e)}
                value={typeFilter}
                style={{ maxWidth: "180px" }}
                placeholder={t("select_${a}", { a: t("type") })}
              >
                {types.map((type) => {
                  return (
                    <>
                      <option key={"type_" + type} value={type}>
                        {type}
                      </option>
                    </>
                  );
                })}
              </select>
              {typeFilter !== undefined && typeFilter !== null && (
                <a
                  href="#"
                  className="inbooma-select-box__reset"
                  onClick={() => onTypeFilterChange("all")}
                  style={{ float: "unset", paddingLeft: "8%" }}
                >
                  x
                </a>
              )}
            </ul>

            <SidebarFilter
              id="inb-c-left-bar-flist--errors-date"
              heading={t("timespan", null, "capital")}
              type="datePicker"
              data={[
                {
                  name: "date",
                  className: "noBorders-noBackground",
                  dateFormat: "dd.MM.y",
                  selected: selectedDate,
                  onChangeHandle: selectedDateHandle,
                  onKeyDownHandle: dateKeyDownHandle,
                  placeholder: t("created", null, "capital") + " ...",
                },
              ]}
            />
          </div>
        </>
      )}
      <footer className="inb-c-left-bar__footer small-only-float-container center-on-content">
        <a
          href="#"
          id="toggle-left-bar"
          className="button secondary show-for-small-only"
          onClick={(e) => onToggleLeftBar(e)}
        >
          <i className="fi fi-filter"></i>
          <span className="show-for-sr">t('open_filter_menu')</span>
        </a>
      </footer>
    </aside>
  );
};

export default ErrorsSidebar;
